// TODO: Get Date Utils for LOCO

export const dateString = (date) => {

    // ***** TODO: SUNSET - NOT IN USE *****

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c dateString', 'font-weight: bold; color: none',
            '\n' + ' - date.typeof:', typeof date + '\n',
            { date }
        );
    }

    if (date instanceof Date) {
        return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    }
    else {
        if (date) {
            return dateString(new Date(date));
        }
        else {
            return '';

        }
    }
};

export const dateTimeString = (date) => {

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c dateTimeString', 'font-weight: bold; color: none',
            '\n' + ' - date.typeof:', typeof date + '\n',
            { date }
        );
    }

    if (date instanceof Date) {
        return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + date.toLocaleTimeString();
    }
    else {
        if (date) {
            let newDate = new Date(date);
            return newDate.toLocaleDateString() + ' ' + addZero(newDate.getHours()) + ':' + addZero(newDate.getMinutes()) + ':' + addZero(newDate.getSeconds()) + '.' + newDate.getMilliseconds();
        }
        else {
            return '';

        }
    }
};

export const dateMonthYearString = (date) => {

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c dateMonthYearString', 'font-weight: bold; color: none',
            '\n' + ' - date.typeof:', typeof date + '\n',
            { date }
        );
    }

    if (date instanceof Date) {
        return (date.toLocaleString('en-US', { month: 'short' }) + ' ' + date.getFullYear());
    }
    else {
        if (date) {
            return dateMonthYearString(new Date(date));
        }
        else {
            return '';

        }
    }
};

export const dateMonthDigitString = (date) => {

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c dateMonthDigitString', 'font-weight: bold; color: none',
            '\n' + ' - date.typeof:', typeof date + '\n',
            { date }
        );
    }

    if (date instanceof Date) {
        return date.getMonth();
        // return date.toLocaleString('en-US', { month: '2-digit' });
    }
    else {
        if (date) {
            return dateMonthDigitString(new Date(date));
        }
        else {
            return '';

        }
    }
};

export const getdateYearUTC = (date) => {

    // ***** TODO: SUNSET - NOT IN USE *****

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c getdateYearUTC', 'font-weight: bold; color: none',
            '\n' + ' - date.typeof:', typeof date + '\n',
            { date }
        );
    }

    if (date instanceof Date) {
        return date.getUTCFullYear();
    }
    else {
        if (date) {
            return new Date(date).getUTCFullYear();
        }
        else {
            return '';

        }
    }
};

export const dateStringForQuery = (date) => {

    // ***** TODO: SUNSET - NOT IN USE *****

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c dateStringForQuery', 'font-weight: bold; color: none',
            '\n' + ' - date.typeof:', typeof date + '\n',
            { date }
        );
    }

    if (date instanceof Date) {
        let dateObj = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        return dateObj.toString();
    }
    else {
        if (date) {
            return dateStringForQuery(new Date(date));
        }
        else {
            return '';

        }
    }
};

export const getDuration = (startDate, finishDate) => {

    // ***** TODO: SUNSET - NOT IN USE *****

    // Console logging flag
    const logToConsole = false;

    const date1 = new Date(startDate);
    const date2 = new Date(finishDate);
    const diff = new Date(date2 - date1);
    const diffYear = diff.getUTCFullYear() - 1970;
    const diffMonth = diff.getUTCMonth();

    let duration = null;
    if (diffYear === 0) {
        if (diffMonth === 1) {
            duration = diffMonth + ' month';
        } else {
            duration = diffMonth + ' months';
        }
    }
    else if (diffYear === 1) {
        if (diffMonth === 0) {
            duration = diffYear + ' year';
        }
        else if (diffMonth === 1) {
            duration = diffYear + ' year, ' + diffMonth + ' month';
        } else {
            duration = diffYear + ' year, ' + diffMonth + ' months';
        }
    }
    else {
        if (diffMonth === 0) {
            duration = diffYear + ' years';
        }
        else if (diffMonth === 1) {
            duration = diffYear + ' years, ' + diffMonth + ' month';
        } else {
            duration = diffYear + ' years, ' + diffMonth + ' months';
        }
    }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c getDuration', 'font-weight: bold; color: none',
            '\n' + ' - startDate.typeof:', typeof startDate,
            '\n' + ' - finishDate.typeof:', typeof finishDate,
            '\n' + ' - duration.typeof:', typeof duration + '\n',
            { startDate },
            { finishDate },
            { duration }
        );
    }

    return duration;
};

export const getDateNode = (date, type) => {

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c getDateNode', 'font-weight: bold; color: none',
            '\n' + 'date.typeof: ', typeof date,
            '\n' + 'type.typeof: ', typeof type + '\n',
            { date },
            { type }
        );
    }

    if (date instanceof Date) {
        if (type.toLowerCase() === 'day') {
            return date.getDate();
        }
        else if (type.toLowerCase() === 'month') {
            return date.toLocaleString('en-US', { month: 'long' });
        }
        else if (type.toLowerCase() === 'year') {
            return date.getFullYear();
        }
        return '';
    }
    else{
            if (date) {
            return getDateNode(new Date(date), type);
        } else {
            return '';
        }
    }
};

function addZero(i) {

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c addZero', 'font-weight: bold; color: none',
            '\n' + 'i.typeof: ', typeof i + '\n',
            { i }
        );
    }

    if (i < 10) {
        i = "0" + i;
    }

    return i;
}
